import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { ApplicationProfileEntity } from "src/app/features/ApplicationProfile/types/ApplicationProfileEntity";
import { Checkbox, SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { appProfileCardTypeSelectConfig, statusSelectorConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const ApplicationProfilesSearchForm: FC<SearchFormProps<ApplicationProfileEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("applicationProfileCreateForm.cardType")} name="cardTypeId">
                <SelectDynamic
                    name="cardTypeId"
                    label={t("applicationProfileCreateForm.cardType")}
                    fieldConfig={appProfileCardTypeSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
            <Form.Item label={t("contractSearchForm.criteriaBadges.archived")} name="archived" valuePropName="checked">
                <Checkbox name="archived" label="" readOnly={false} />
            </Form.Item>
        </SearchForm>
    );
};
